import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    awardId: 0,
    awardDetailId: '', // 卓越奖项申报详情ID
    curActivityId: '',
    lecturerId: '', // 讲师ID
    reportIDStr: '', // 报告ID
    token: null,
    tokenExpire: null,
    tagsStoreList: [],
    language: Cookies.get('language') || 'en',
  },
  mutations: {
    saveCurActivityId(state, data) {
      state.curActivityId = data
      window.localStorage.setItem('curActivityId', data)
    },
    // 卓越奖项申报详情 AwardId(
    saveAwardId(state, data) {
      state.awardId = data
      window.localStorage.setItem('awardId', data)
    },
    // 卓越奖项申报详情 ID
    saveAwardDetailId(state, data) {
      state.awardDetailId = data
      window.localStorage.setItem('awardDetailId', data)
    },
    saveLecturerId(state, data) {
      state.lecturerId = data
      window.localStorage.setItem('lecturerId', data)
    },
    saveReportIDStr(state, data) {
      state.reportIDStr = data
      window.localStorage.setItem('reportIDStr', data)
    },
    saveToken(state, data) {
      state.token = data
      window.localStorage.setItem('Token', data)
    },
    saveTokenExpire(state, data) {
      state.tokenExpire = data
      window.localStorage.setItem('TokenExpire', data)
    },
    saveTagsData(state, data) {
      state.tagsStoreList = data
      sessionStorage.setItem('Tags', data)
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
  },
  getters: {
    getCurActivityId(state) {
      if (!state.curActivityId) {
        state.curActivityId = window.localStorage.getItem('curActivityId')
      }
      return state.curActivityId
    },
    // 卓越奖项申报详情 ID
    getAwardDetailId(state) {
      if (!state.awardDetailId) {
        state.awardDetailId = window.localStorage.getItem('awardDetailId')
      }
      return state.awardDetailId
    },
    // 卓越奖项申报详情 AwardId
    getAwardId(state) {
      if (!state.awardId) {
        state.awardId = window.localStorage.getItem('awardId')
      }
      return state.awardId
    },
    getCurLecturerId(state) {
      if (!state.lecturerId) {
        state.lecturerId = window.localStorage.getItem('lecturerId')
      }
      return state.lecturerId
    },
    getCurReportIDStr(state) {
      if (!state.reportIDStr) {
        state.reportIDStr = window.localStorage.getItem('reportIDStr')
      }
      return state.reportIDStr
    },
  },
})
